import { calculateWordCount } from "../content-details-sections/word-count";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { getMistakesInStatement } from "../statment-analysis-scoring/countMistakesInStatement";
import { ProjectScoreAnalysis } from "../types";



export const getProjectScore = (projects: ResumeAnalysis["projects"], maxScoreOfSection: number): ProjectScoreAnalysis => {
  if (!projects || projects.individualProjectsAnalysis.length === 0) {
    return {
      totalScore: 0,
      statementMistakeCount: 0,
      informationMistakeCount: 0,
      linkMistakeCount: 0,
      totalMistakeCount: 0
    };
  }
  let statementMistakeCount = 0;
  let informationMistakeCount = 0;
  let linkMistakeCount = 0;
  let totalMistakeCount = 0;

  projects.individualProjectsAnalysis.forEach((project) => {
    if (!project.project) {
      informationMistakeCount++;
    }
    if (!project.startDate && !project.endDate) {
      informationMistakeCount++;
    }

    if (!project.projectLink) {
      linkMistakeCount++;
    }

    project.descriptionAnalysis.forEach((statement) => {
      statementMistakeCount += getMistakesInStatement(statement.analysis);
    }

    );
    if(project.descriptionAnalysis.length < 2) {
      statementMistakeCount++;
    }
    const hasImpactfulStatement = project.descriptionAnalysis.find(statement => statement.analysis.isQuantified === 1);
    if (!hasImpactfulStatement) {
      statementMistakeCount++;
    }

    const longSentences = project.descriptionAnalysis
        .filter(desc => calculateWordCount(desc.statement) > 25)
        .map(desc => desc.statement);
    statementMistakeCount += longSentences.length;
  }
  );

  totalMistakeCount = statementMistakeCount + informationMistakeCount;

  let totalScore = maxScoreOfSection;
  if (totalMistakeCount > 0 && totalMistakeCount <= 3) {
    totalScore -= 0.1 * maxScoreOfSection;
  } else if (totalMistakeCount > 3 && totalMistakeCount <= 6) {
    totalScore -= 0.25 * maxScoreOfSection;
  } else if (totalMistakeCount > 6 && totalMistakeCount <= 12) {
    totalScore -= 0.4 * maxScoreOfSection;
  } else if (totalMistakeCount > 12 && totalMistakeCount <= 18) {
    totalScore -= 0.6 * maxScoreOfSection;
  } else if (totalMistakeCount > 18) {
    totalScore -= 0.8 * maxScoreOfSection;
  }

  return {
    totalScore: totalScore,
    statementMistakeCount,
    informationMistakeCount,
    linkMistakeCount,
    totalMistakeCount
  };
}
